import * as React from 'react';

const AppointmentIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16}>
    <path
      fill={fillColor}
      d="M12.647 15.494H3.01A2.982 2.982 0 0 1 0 12.54V4.263a2.924 2.924 0 0 1 .881-2.09 3.044 3.044 0 0 1 2.13-.866h9.637c.796 0 1.56.31 2.13.867a2.924 2.924 0 0 1 .88 2.089v8.278a2.982 2.982 0 0 1-3.01 2.953ZM3.01 2.5a1.79 1.79 0 0 0-1.807 1.763v8.278a1.793 1.793 0 0 0 1.807 1.772h9.637a1.793 1.793 0 0 0 1.807-1.772V4.263A1.79 1.79 0 0 0 12.647 2.5H3.01Z"
    />
    <path
      fill={fillColor}
      d="M12.646 13.138h-2.41a.61.61 0 0 1-.609-.61v-2.403a.61.61 0 0 1 .61-.61h2.41a.61.61 0 0 1 .61.61v2.41a.61.61 0 0 1-.61.603Zm-1.81-1.218h1.202v-1.192h-1.201v1.192ZM13.368 6.054H2.288a.631.631 0 0 1 0-1.218h11.08a.632.632 0 0 1 0 1.218ZM4.817 3.726a.61.61 0 0 1-.61-.61V.713a.61.61 0 1 1 1.219 0v2.403a.61.61 0 0 1-.61.604l.001.006ZM10.841 3.726a.61.61 0 0 1-.61-.61V.713a.61.61 0 1 1 1.202 0v2.403a.61.61 0 0 1-.594.604l.002.006Z"
    />
  </svg>
);

export default AppointmentIcon;
